export default rendererMode => {
    return {
        hocs: [],
        onRedirect: () => console.log("redirect handler admin extension")
    };
};